import { PRIVACY_CHANNELS } from "../../../../features/privacy/definitions";

export const DEFAULT_PRIVACY_LABELS = {
  website: "Website",
  newsletter: "Newsletter",
  socials: "Social media",
  promotionalMaterials: "Promotional materials",
  internalPublications: "Internal publications",
  localMedia: "Local media",
  videoRecordings: "Video recordings",
};

export const PRIVACY_HELP_TEXT = {
  website: "Naam en foto op de website",
  newsletter: "Naam in de nieuwsbrief",
  socials: "Naam en foto op social media",
  promotionalMaterials: "Naam en foto in promotiemateriaal",
  internalPublications: "Naam in interne publicaties",
  localMedia: "Naam en foto in lokale media",
  videoRecordings: "Video-opnames toestaan",
};

export const getEnabledPrivacyCount = (privacy) =>
  PRIVACY_CHANNELS.filter(({ key }) => !!privacy?.[key]).length;
